module.exports = __webpack_public_path__ + "static/header-main-school-0f3a04568d0eeaca81336f286bc17bb1.png";